import React, { ReactElement, useState, useMemo, useEffect } from 'react'
import { Button, Space, Pagination, Popover, Input, Tooltip } from 'antd'
import { StopOutlined, HighlightOutlined } from '@ant-design/icons'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const IconComp = (props: {
    isUser?: boolean
    messageId: number
    isLastQuestion?: boolean
    isLastAnswer?: boolean
    isLast?: boolean
    // eslint-disable-next-line no-unused-vars
    onEditUserQuestion?: (messageId: number) => void
    // eslint-disable-next-line no-unused-vars
    onEditAnswer?: (messageId: number) => void
    // eslint-disable-next-line no-unused-vars
    onCopy?: (messageId: number) => void
    // eslint-disable-next-line no-unused-vars
    onZan?: (messageId: number, comment: string) => void
    zanComment?: string
    // eslint-disable-next-line no-unused-vars
    onCai?: (messageId: number, comment: string) => void
    caiComment?: string
    // eslint-disable-next-line no-unused-vars
    onDel?: (messageId: number) => void
    // eslint-disable-next-line no-unused-vars
    onGenerate?: (messageId: number) => void
    // eslint-disable-next-line no-unused-vars
    onStop?: (messageId: number) => void
    isSummary?: 0 | 1
    // eslint-disable-next-line no-unused-vars
    onSummary?: (messageId: number) => void
    vote?: number
    generating?: boolean
    pageIndex?: () => number
    pageNums?: () => number
    // eslint-disable-next-line no-unused-vars
    getHistoryQuestion?: (messageId: number, page: number) => void
    // eslint-disable-next-line no-unused-vars
    getHistoryAnswer?: (messageId: number, page: number) => void
}): ReactElement => {
    const { isUser, messageId, onEditUserQuestion, onEditAnswer, isLastQuestion, isLastAnswer,
        onCopy, onZan, zanComment, onCai, caiComment, onDel, vote, onGenerate, onStop, generating,
        pageIndex, pageNums, getHistoryQuestion, getHistoryAnswer, onSummary, isSummary, isLast
    } = props
    const { TextArea } = Input
    const [zanCommentLocal, setZanCommentLocal] = useState(zanComment ?? '')
    const [caiCommentLocal, setCaiCommentLocal] = useState(caiComment ?? '')
    const [zanOpen, setZanOpen] = useState(false)
    const [caiOpen, setCaiOpen] = useState(false)
    const [questionPage, setQuestionPage] = useState(1)
    const [answerPage, setAnswerPage] = useState(1)

    const onChangeQuestionPage = (page: number) => {
        setQuestionPage(page)
        getHistoryQuestion && getHistoryQuestion(messageId, page)
    }
    const onChangeAnswerPage = (page: number) => {
        setAnswerPage(page)
        getHistoryAnswer && getHistoryAnswer(messageId, page)
    }

    const total = useMemo(() => {
        return pageNums ? pageNums() : 1
    }, [messageId])

    useEffect(() => {
        if (isUser) {
            setQuestionPage(pageIndex ? pageIndex() : 1)
        } else {
            setAnswerPage(pageIndex ? pageIndex() : 1)
        }
    }, [pageIndex])

    return isUser ? (<Space size={1} style={{ width: '100%', paddingTop: 5, textAlign: 'right',
        justifyContent: 'flex-end' }}>
        <Button className='opt_btn'
            title='编辑'
            icon={
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.3" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"></path></svg>
            }
            onClick={() => {
                onEditUserQuestion && onEditUserQuestion(messageId)
            }}
        />
        <Button className='opt_btn'
            title='复制'
            icon={
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.3" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"></path></svg>
            }
            onClick={() => {
                onCopy && onCopy(messageId)
            }}
        />
        {isLastQuestion && <Button className='opt_btn'
            title='删除'
            icon={
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"></path></svg>
            }
            onClick={() => {
                onDel && onDel(messageId)
            }}
        />}
        {total > 1 && <Pagination simple current={questionPage} pageSize={1} total={total}
            className='pagin_question'
            onChange={onChangeQuestionPage}
        />}
    </Space>)
        : (<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Space size={1} style={{ paddingTop: 5 }}>
                {total > 1 && <Pagination simple current={answerPage} pageSize={1} total={total}
                    className='pagin_question'
                    onChange={onChangeAnswerPage}
                    disabled={generating}
                />}
                {!generating && <Button className='opt_btn'
                    title='编辑'
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.3" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"></path></svg>
                    }
                    onClick={() => {
                        onEditAnswer && onEditAnswer(messageId)
                    }}
                />}
                {!generating && <Button className='opt_btn'
                    title='复制'
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.3" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M15.666 3.888A2.25 2.25 0 0013.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 01-2.25 2.25H6.75A2.25 2.25 0 014.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 011.927-.184"></path></svg>
                    }
                    onClick={() => {
                        onCopy && onCopy(messageId)
                    }}
                />}
                <Popover visible={zanOpen} overlayClassName='comment_pop'
                    onVisibleChange={setZanOpen}
                    content={<div className='comment_box'>
                        <TextArea rows={2} placeholder='请输入评论' style={{ width: 400 }}
                            value={zanCommentLocal}
                            onChange={(e) => setZanCommentLocal(e.target.value)}
                        ></TextArea>
                        <div style={{ marginTop: 5, textAlign: 'right' }}>
                            <Button type='primary' onClick={() => {
                                onZan && onZan(messageId, zanCommentLocal)
                                setZanOpen(false)
                            }}>提交</Button>
                        </div>
                    </div>} title={<b>评论</b>} trigger="click"
                >
                    {!generating && messageId > 0 && <Button className={`opt_btn ${vote === 1 ? 'zan' : ''}`}
                        title='赞'
                        icon={
                            <svg stroke="currentColor" fill="none" strokeWidth="2.3" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg>
                        }
                        onClick={() => {
                            setZanOpen(true)
                        }}
                    />}
                </Popover>
                <Popover visible={caiOpen} overlayClassName='comment_pop'
                    onVisibleChange={setCaiOpen}
                    content={<div className='comment_box'>
                        <TextArea rows={2} placeholder='请输入评论' style={{ width: 400 }}
                            value={caiCommentLocal}
                            onChange={(e) => setCaiCommentLocal(e.target.value)}
                        ></TextArea>
                        <div style={{ marginTop: 5, textAlign: 'right' }}>
                            <Button type='primary' onClick={() => {
                                onCai && onCai(messageId, caiCommentLocal)
                                setCaiOpen(false)
                            }}>提交</Button>
                        </div>
                    </div>} title={<b>评论</b>} trigger="click"
                >
                    {!generating && messageId > 0 && <Button className={`opt_btn ${vote === -1 ? 'cai' : ''}`}
                        title='踩'
                        icon={
                            <svg stroke="currentColor" fill="none" strokeWidth="2.3" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path></svg>
                        }
                        onClick={() => {
                            setCaiOpen(true)
                        }}
                    />}
                </Popover>
                {/* 最后一条回答 可重新生成 */}
                {/* 重新生成过程中不能再点击，只能在中断后才可用 */}
                {isLastAnswer && !generating && <Button className='opt_btn'
                    title='重新生成'
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.3" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"></path></svg>
                    }
                    onClick={() => {
                        onGenerate && onGenerate(messageId)
                    }}
                />}
                {generating && <Button className='opt_btn'
                    title='中断生成'
                    icon={
                        <StopOutlined />
                    }
                    onClick={() => {
                        onStop && onStop(messageId)
                    }}
                />}
            </Space>
            {isLast && isSummary !== 1 && !generating && messageId > 0 && <Button
                type="ghost"
                style={{ width: 110, height: 'auto', borderColor: '#2589cc' }}
                title='提案对接'
                icon={
                    <Tooltip placement="top" title="依据需求关键技术点，关联ITMT技术提案"><div
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                        <span style={{ fontSize: 15, fontWeight: 'bold' }}>提案对接</span>
                        <HighlightOutlined style={{ fontSize: 22, color: '#036fc0' }} />
                    </div></Tooltip>
                }
                onClick={() => {
                    onSummary && onSummary(messageId)
                }}
            />}
        </div>)
}

export default IconComp